import UIHelper from '../ui-helper';
import {
    SELECTION_AS_IS,
    FIRST_VS_LATEST,
    FIRST_VS_HIGHEST,
    HIGHEST_VS_LATEST
} from '../../containers/participation/student/student-constants';
import { getTotalCurriculumAndLivePoints } from '../../containers/participation/helpers/utils';

/**
 * Responsible for converting participation report data from redux store into format
 * needed for export endpoints
 */
export default class ParticipationDataConverter {
    static IMPROVEMENT_MAP = {
        [FIRST_VS_LATEST]: 0,
        [HIGHEST_VS_LATEST]: 1,
        [FIRST_VS_HIGHEST]: 2
    };

    static convertAllClasses(
        data,
        selectedDate,
        reportTitle,
        participationKey,
        tableTitle,
        sessionId
    ) {
        const {
            classroomParticipations,
            certificates,
            classroomUsage,
            newCertificate
        } = data;
        const { gold, silver, bronze } = certificates;
        const usage = classroomUsage[0];
        const { totalCurriculumPoints } = getTotalCurriculumAndLivePoints(
            classroomParticipations
        );

        return {
            dateRange: UIHelper.formatDateRange(selectedDate),
            reportLevelHeader: reportTitle,
            participationTableTitle: tableTitle,
            [participationKey]: {
                classroomParticipations,
                totalGold: gold,
                totalSilver: silver,
                totalBronze: bronze,
                newCertificate,
                totalSignIns: usage.totalSignIns,
                totalTimeOnline: usage.totalTimeOnline,
                totalActivityPoints: totalCurriculumPoints,
                totalLivePoints: usage.totalLiveMathsPoints,
                sessionId
            }
        };
    }

    static convertSingleClass(data, selectedDate, groupId, tableTitle) {
        const { classroomName } = data;
        let { classroomGroupParticipations, usage, certificateDetails } = data;

        if (groupId) {
            classroomGroupParticipations = classroomGroupParticipations.filter(
                (g) => g.id === groupId
            );
            ({ certificateDetails, usage } = classroomGroupParticipations[0]);
        }

        return {
            dateRange: UIHelper.formatDateRange(selectedDate),
            participationTableTitle: tableTitle,
            classroomParticipationData: {
                classroomName,
                accessDetails: usage[0],
                certificateDetails,
                classroomGroupParticipations
            }
        };
    }

    static convertStudent(
        data,
        selectedDate,
        improvement,
        selectedImprovements
    ) {
        let topicParticipations;
        if (improvement === SELECTION_AS_IS) {
            topicParticipations = data.topicParticipations.map(
                (topic) => ({
                    ...topic,
                    improvementType: this.IMPROVEMENT_MAP[
                        selectedImprovements[topic.id]
                    ]
                }),
                this
            );
        } else {
            const improvementType = this.IMPROVEMENT_MAP[improvement];
            topicParticipations = data.topicParticipations.map(
                (topic) => ({ ...topic, improvementType }),
                this
            );
        }

        return {
            dateRange: UIHelper.formatDateRange(selectedDate),
            studentParticipationData: { ...data, topicParticipations }
        };
    }
}



// WEBPACK FOOTER //
// ./helpers/export-data-converter/participation-data-converter.js